'use client'
import { ROUTES } from '@/core/constants/routes'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { Category } from '@/features/categories/model/category.model'
import Link from 'next/link'

type Props = {
  category: Category
}
export const CategoryItem = ({ category }: Props) => (
  <Link href={ROUTES.search + `?categories=${encodeURIComponent(category.id)}`}>
    <div className='flex flex-col items-center'>
      <div
        className='bg-anti-flash border-creamed-cron relative mb-1 flex aspect-square items-center justify-center rounded-full border-1 p-4'
        style={{
          width: '100%',
          maxWidth: '95px',
          aspectRatio: '1 / 1',
        }}
      >
        <RemoteImage
          src={category?.image[0]?.original_url}
          alt={category?.name}
          fill
          className='rounded-full object-cover'
        />
      </div>
      <span className='text-md mt-2 w-full text-center font-medium break-words'>
        {category?.name}
      </span>
    </div>
  </Link>
)
